<template>
  <div>
    <!-- 上传文件组件 -->
    <el-upload
      ref="upload"
      :action="getActionUrl"
      list-type="picture-card"
      :multiple="multiple"
      :limit="limit"
      :headers="myHeaders"
      :file-list="fileList"
      :on-exceed="handleExceed"
      :on-preview="handleUploadPreview"
      :on-remove="handleRemove"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadErr"
      :before-upload="handleBeforeUpload"
    >
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip" style="color:#838fa1;">{{tip}}</div>
    </el-upload>
    <div style="margin-top: 8px;">
      <el-button size="mini" @click="openMediaDialog">{{ $t('fileUpload.selectFromLibrary') }}</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" size="tiny" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt>
    </el-dialog>
    <!-- 素材库弹窗 -->
    <el-dialog :visible.sync="mediaDialogVisible" :title="$t('fileUpload.dialogTitle')" width="60%" append-to-body>
      <div v-loading="mediaLoading">
        <el-row :gutter="12">
          <el-col :span="6" v-for="(item, idx) in mediaList" :key="idx" style="margin-bottom: 12px;">
            <div
              :style="{
                border: mediaSelectedMap[item] ? '2px solid #409EFF' : '1px solid #eaeefb',
                borderRadius: '4px',
                padding: '4px',
                cursor: 'pointer'
              }"
              @click="toggleSelectMedia(item)"
            >
              <img :src="previewUrl(item)" style="width: 100%; height: 120px; object-fit: cover;" />
              <div style="text-align:center; font-size:12px; color:#909399; margin-top:4px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{ baseName(item) }}</div>
            </div>
          </el-col>
        </el-row>
        <div v-if="!mediaLoading && mediaList.length === 0" style="text-align:center; color:#909399;">{{ $t('fileUpload.empty') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mediaDialogVisible=false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="confirmSelectMedia">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import storage from "@/utils/storage";
import base from "@/utils/base";
export default {
  data() {
    return {
      // 查看大图
      dialogVisible: false,
      // 查看大图
      dialogImageUrl: "",
      // 组件渲染图片的数组字段，有特殊格式要求
      fileList: [],
      fileUrlList: [],
      myHeaders:{},
      // 素材库
      mediaDialogVisible: false,
      mediaLoading: false,
      mediaList: [], // 相对路径数组，如 upload/xxx.png
      mediaSelectedMap: {}
    };
  },
  props: ["tip", "action", "limit", "multiple", "fileUrls"],
  mounted() {
    this.init();
    this.myHeaders= {
      'Token':storage.get("Token")
    }
  },
  watch: {
    fileUrls: function(val, oldVal) {
      //   console.log("new: %s, old: %s", val, oldVal);
      this.init();
    }
  },
  computed: {
    // 计算属性的 getter
    getActionUrl: function() {
      // 直传后端：绝对地址，避免通过 Pages 相对路径
      return (this.$base.url.endsWith('/') ? this.$base.url : this.$base.url + '/') + this.action;
    }
  },
  methods: {
    // 打开素材库
    openMediaDialog() {
      this.mediaDialogVisible = true;
      this.fetchMediaList();
    },
    // 拉取素材库
    async fetchMediaList() {
      this.mediaLoading = true;
      this.mediaSelectedMap = {};
      try {
        const res = await this.$http.get('file/list');
        const list = (res && res.data && (res.data.data || res.data)) || [];
        // 规范为相对路径数组
        this.mediaList = Array.isArray(list) ? list : [];
      } catch (e) {
        this.$message.error(this.$t('fileUpload.fetchFailed'));
      } finally {
        this.mediaLoading = false;
      }
    },
    // 切换选择
    toggleSelectMedia(relativePath) {
      this.$set(this.mediaSelectedMap, relativePath, !this.mediaSelectedMap[relativePath]);
    },
    // 生成预览完整URL（带token）
    previewUrl(relativePath) {
      let preview = relativePath;
      const baseUrl = this.$base.imgurl || '';
      if (!/^https?:\/\//.test(preview)) {
        preview = (baseUrl.endsWith('/') ? baseUrl : baseUrl + '/') + relativePath.replace(/^\//, '');
      }
      const token = storage.get('Token') || storage.get('token');
      return preview + (preview.includes('?') ? '&' : '?') + 'token=' + token;
    },
    baseName(p) {
      if (!p) return '';
      const i = p.lastIndexOf('/');
      return i >= 0 ? p.substring(i + 1) : p;
    },
    // 确认选择
    confirmSelectMedia() {
      const selected = Object.keys(this.mediaSelectedMap).filter(k => this.mediaSelectedMap[k]);
      if (selected.length === 0) {
        this.mediaDialogVisible = false;
        return;
      }
      // 限制数量
      const currentCount = this.fileUrlList.length;
      let allowed = selected;
      if (this.limit && Number(this.limit) > 0) {
        const canAdd = Math.max(0, Number(this.limit) - currentCount);
        if (selected.length > canAdd) {
          allowed = selected.slice(0, canAdd);
          this.$message.warning(this.$t('fileUpload.limitReached', { count: canAdd }));
        }
      }
      if (allowed.length === 0) {
        this.mediaDialogVisible = false;
        return;
      }
      // 将选择的相对路径合并到当前fileList
      const appendFiles = allowed.map((rel, idx) => ({ name: `lib-${Date.now()}-${idx}`, url: rel }));
      // 构造新的原始列表：用当前的相对路径 + append 的相对路径
      const rawFiles = this.fileUrlList.map((rel, idx) => ({ name: `exist-${idx}`, url: rel })).concat(appendFiles);
      this.setFileList(rawFiles);
      this.$emit('change', this.fileUrlList.join(','));
      this.mediaDialogVisible = false;
    },
    // 初始化
    init() {
      //   console.log(this.fileUrls);
      if (this.fileUrls) {
        this.fileUrlList = this.fileUrls.split(",");
        let fileArray = [];
        this.fileUrlList.forEach(function(item, index) {
          var url = item;
          var name = index;
          var file = {
            name: name,
            url: url
          };
          fileArray.push(file);
        });
        this.setFileList(fileArray);
      }
    },
    handleBeforeUpload(file) {
	
    },
    // 上传文件成功后执行
    // handleUploadSuccess(res, file, fileList) {
    //     console.log("上传响应", res);

    //   if (res && res.code === 0) {
    //     console.log("上传成功", res);
        
    //     fileList[fileList.length - 1]["url"] = "upload/" + file.response.file;
    //     this.setFileList(fileList);
    //     this.$emit("change", this.fileUrlList.join(","));
    //   } else {
    //     console.log("上传失败", res);
        
    //     this.$message.error(res.msg);
    //   }
    // },
    // 上传文件成功后执行
handleUploadSuccess(res, file, fileList) {
  console.log("上传响应", res);
  
  // 检查响应数据结构
  let fileUrl = '';
  
  // 处理XML格式的响应
  if (typeof res === 'string' && res.includes('<R>')) {
    try {
      // 提取文件名
      const fileMatch = res.match(/<file>(.*?)<\/file>/);
      if (fileMatch && fileMatch[1]) {
        console.log("fileMatch", fileMatch);
        
        fileUrl = fileMatch[1];
      }
    } catch (e) {
      console.error('解析XML响应失败', e);
    }
  }
  // 处理JSON格式的响应
  else if (res && res.code === 0) {
    console.log("上传成功", res);
    
    if (res.file) {
      fileUrl = res.file;
    } else if (res.data && res.data.file) {
      fileUrl = res.data.file;
    }
  }
  
  // 更新文件列表
  if (fileUrl) {
    console.log("fileList", fileList);
    // 规范为相对路径：upload/文件名
    if (!fileUrl.startsWith('upload/')) {
      fileUrl = `upload/${fileUrl}`
    }
    fileList[fileList.length - 1]["url"] = fileUrl;
    console.log("fileList2", fileList);
    this.setFileList(fileList);
    // 回传给父组件用于入库的相对路径
    this.$emit("change", this.fileUrlList.join(","));
    console.log("上传成功，文件URL:", this.fileUrlList);
    
    console.log("文件URL:", fileUrl);
  } else {
    console.error("无法从响应中获取文件URL");
    this.$message.error(this.$t('fileUpload.missingFileUrl'));
  }
},

    // 图片上传失败
    handleUploadErr(err, file, fileList) {
      this.$message.error(this.$t('fileUpload.uploadFailed'));
    },
    // 移除图片
    handleRemove(file, fileList) {
      this.setFileList(fileList);
      this.$emit("change", this.fileUrlList.join(","));
    },
    // 查看大图
    handleUploadPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 限制图片数量
    handleExceed(files, fileList) {
      this.$message.warning(this.$t('fileUpload.uploadLimit', { limit: this.limit }));
    },
    // 重新对fileList进行赋值
    setFileList(fileList) {
      var fileArray = [];
      var fileUrlArray = [];
      // 有些图片不是公开的，所以需要携带token信息做权限校验
      var token = storage.get("token");
      let _this = this;
      fileList.forEach(function(item, index) {
        // 原始url（可能是相对路径或完整路径），去掉查询参数
        var raw = (item.url || '').split("?")[0];
        // 计算相对路径
        var relative = raw;
        var baseUrl = _this.$base.imgurl || '';
        if (relative.startsWith(baseUrl)) {
          relative = relative.substring(baseUrl.length);
        }
        if (relative.startsWith('/')) {
          relative = relative.substring(1);
        }
        if (!relative.startsWith('upload/')) {
          // 如果是纯文件名，补上 upload/
          if (/^[A-Za-z0-9_\-]+\.[A-Za-z0-9]+$/.test(relative)) {
            relative = 'upload/' + relative;
          }
        }
        // 生成用于预览的完整URL
        var preview = relative;
        if (!/^https?:\/\//.test(preview)) {
          if (baseUrl.endsWith('/')) {
            preview = baseUrl + relative;
          } else {
            preview = baseUrl + '/' + relative;
          }
        }
        var name = item.name;
        var file = {
          name: name,
          url: preview + "?token=" + token
        };
        fileArray.push(file);
        // 回传用于入库的相对路径
        fileUrlArray.push(relative);
      });
      this.fileList = fileArray;
      this.fileUrlList = fileUrlArray;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
